<template>
    <div class="inline-block relative">
        <div class="relative">
            <svg width="199" height="145" viewBox="0 0 199 145" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_5721_90988)" data-figma-bg-blur-radius="8">
                    <path
                        d="M13.0202 11C13.0202 6.5817 16.6019 3 21.0202 3H93.8843C97.2542 3 100.263 5.11176 101.408 8.28107L104.323 16.3466C105.468 19.5159 108.477 21.6277 111.847 21.6277H177.98C182.398 21.6277 185.98 25.2094 185.98 29.6277V130C185.98 134.418 182.398 138 177.98 138H21.0196C16.6013 138 13.0196 134.418 13.0196 130L13.0202 11Z"
                        fill="#D5F4FE"
                        fill-opacity="0.5"
                        shape-rendering="crispEdges"
                    />
                    <path
                        d="M21.0205 3.5H93.8848C97.0439 3.50018 99.8638 5.48009 100.938 8.45117L103.853 16.5166C105.069 19.884 108.266 22.1279 111.847 22.1279H177.979C182.122 22.1279 185.479 25.4858 185.479 29.6279V130C185.479 134.142 182.122 137.5 177.979 137.5H21.0195C16.8774 137.5 13.5195 134.142 13.5195 130L13.5205 11C13.5205 6.85788 16.8784 3.5 21.0205 3.5Z"
                        stroke="#E5F7FE"
                        shape-rendering="crispEdges"
                    />
                </g>
                <rect
                    x="25.8281"
                    y="15.5273"
                    width="147.669"
                    height="113.399"
                    rx="2.5"
                    fill="#F1F5F9"
                    stroke="#F8FAFC"
                />
                <path
                    d="M20.4541 28.5H178.877C180.275 28.5 181.402 29.6476 181.376 31.0459L179.486 134.473C179.461 135.835 178.349 136.927 176.986 136.927H22.3438C20.9811 136.927 19.8697 135.835 19.8447 134.473L17.9541 31.0459C17.9285 29.6475 19.0555 28.5 20.4541 28.5Z"
                    fill="#F8FAFC"
                    stroke="white"
                />
                <foreignObject x="-1.29834" y="36" width="201.597" height="109"
                    ><div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style="
                            backdrop-filter: blur(3.5px);
                            clip-path: url(#bgblur_1_5721_90988_clip_path);
                            height: 100%;
                            width: 100%;
                        "
                    ></div
                ></foreignObject>
                <g filter="url(#filter1_d_5721_90988)" data-figma-bg-blur-radius="7">
                    <path
                        d="M5.73022 51.6713C5.33724 47.0047 9.01891 43 13.702 43H185.298C189.981 43 193.663 47.0047 193.27 51.6713L186.617 130.671C186.268 134.815 182.803 138 178.645 138H20.3546C16.1966 138 12.7318 134.815 12.3828 130.671L5.73022 51.6713Z"
                        fill="#D5F4FE"
                        fill-opacity="0.4"
                        shape-rendering="crispEdges"
                    />
                    <path
                        d="M13.7021 43.5H185.298C189.688 43.5 193.14 47.2542 192.771 51.6289L186.119 130.629C185.792 134.513 182.544 137.5 178.646 137.5H20.3545C16.4564 137.5 13.208 134.513 12.8809 130.629L6.22852 51.6289C5.86037 47.2542 9.3119 43.5 13.7021 43.5Z"
                        stroke="#E5F7FE"
                        shape-rendering="crispEdges"
                    />
                </g>

                <defs>
                    <filter
                        id="filter0_d_5721_90988"
                        x="5.01953"
                        y="-5"
                        width="188.96"
                        height="151"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="2" />
                        <feGaussianBlur stdDeviation="2.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.146863 0 0 0 0 0.283235 0 0 0 0 0.419608 0 0 0 0.15 0"
                        />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5721_90988" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5721_90988" result="shape" />
                    </filter>
                    <clipPath id="bgblur_0_5721_90988_clip_path" transform="translate(-5.01953 5)">
                        <path
                            d="M13.0202 11C13.0202 6.5817 16.6019 3 21.0202 3H93.8843C97.2542 3 100.263 5.11176 101.408 8.28107L104.323 16.3466C105.468 19.5159 108.477 21.6277 111.847 21.6277H177.98C182.398 21.6277 185.98 25.2094 185.98 29.6277V130C185.98 134.418 182.398 138 177.98 138H21.0196C16.6013 138 13.0196 134.418 13.0196 130L13.0202 11Z"
                        />
                    </clipPath>
                    <filter
                        id="filter1_d_5721_90988"
                        x="-1.29834"
                        y="36"
                        width="201.597"
                        height="109"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation="2.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.146863 0 0 0 0 0.287781 0 0 0 0 0.419608 0 0 0 0.2 0"
                        />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5721_90988" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5721_90988" result="shape" />
                    </filter>
                    <clipPath id="bgblur_1_5721_90988_clip_path" transform="translate(1.29834 -36)">
                        <path
                            d="M5.73022 51.6713C5.33724 47.0047 9.01891 43 13.702 43H185.298C189.981 43 193.663 47.0047 193.27 51.6713L186.617 130.671C186.268 134.815 182.803 138 178.645 138H20.3546C16.1966 138 12.7318 134.815 12.3828 130.671L5.73022 51.6713Z"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
        <div class="absolute inset-0 flex items-center justify-center translate-y-[10%]">
            <vx-button :href="`#/org-units`" color="muted-dark" size="sm">
                <font-awesome-icon widthAuto :icon="faArrowLeft"></font-awesome-icon>
                Back to OUs
            </vx-button>
        </div>
    </div>
</template>
<script setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
</script>
